import { render, staticRenderFns } from "./BaseInfoMonth.vue?vue&type=template&id=55617246"
import script from "./BaseInfoMonth.vue?vue&type=script&lang=js"
export * from "./BaseInfoMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports